//DTO
export interface DriverCommerceDto {
    SearchName: string;
    Skip: number;
    Take: number;
    RiderId: number;
    SortField: string | string[];
    SortOrder: number;
}

export interface PaymentTransactionsDto {
    TimeZoneOffset: number;
    SearchName: string;
    Skip: number;
    Take: number;
    SortField: string | string[];
    SortOrder: number;
    RiderId: number;
    FileType?: number;
    StartDate?: string | null;
    EndDate?: string | null;
    CommerceId?: number;
}

//Response
export interface DriverCommerce {
    Status: string;
    ProgramType: number;
    ProductName: string;
    ProductPrice: number;
    StartDate: string;
    DateAvailed: string;
    ProductId: string;
    RiderId: number;
    CommerceId: number;
}

export interface PaymentTransactions {
    TransactionId: string;
    Status: string;
    TransactionDate: string;
    StandardStaging: number;
    ProgramType: number;
    ProductName: string;
    AmountDeducted: number;
    DueDate: string;
    ProductId: string;
    Balance: number;
    Frequency: number;
    CommerceId: number;
}

export interface DriverCommerceOverview {
    Balance: number;
    FirstTXDate: string;
    LastDeduction: string;
    NextDeduction: string;
    TotalAmountAvailed: number;
}

export interface ProductDetail {
    ProductId: string;
    ProductName: string;
    DateAvailed: string;
    Amount: number;
    StartDate: string;
    Status: number;
    ProductImageUrl: string[];
    Document: DocumentUrl[];
    PaymentPeriod: number;
    AmountPaid: number;
    AmountPaidCount: number;
    Balance: number;
    PaymentTerm: number;
    DeductionFrequency: number;
    StandardAging: number;
    ChangeHistory: any[];
}

export interface DocumentUrl{
    Url: string;
    FileType: number;
}

//enum
export enum DriverCommerceStatus {
    PendingTopup = 1,
    PendingRelease = 2,
    Active = 3,
    Paused = 4,
    Suspended = 5,
    Cancelled = 6,
    Completed = 7,
}

export enum TransactionsStatus {
    Paid = 1,
    Failed = 2,
    Overdue = 3,
    Penalty = 4
}

export enum DeductionFrequency {
    Daily = 1,
    Weekly = 2,
    Monthly = 3
}

export enum CommerceHistory {
    Created = 0,
    Released = 1,
    TermChange = 2,
    Paused = 3,
    Cancelled = 4,
    Suspended = 5,
    Resume = 6,
    BondRelease = 7,
    Completed = 8
}
